import { createApp, h } from "vue";
import { pinia } from "@allwyn/utils/global-pinia";
import { useGlobalNotification } from "./header-stack-partials/global-notification/global-notification";
import { useHeader } from "./header-stack-partials/header/header";
import { useMainMenu } from "./header-stack-partials/main-menu/main-menu";
import { useSmartBanner } from "./header-stack-partials/smart-banner/smart-banner";
import UserMenu from "./header-stack-partials/user-menu/user-menu.vue";

export const useHeaderStack = () => {
    const { useHeaderScrollFeatures } = useHeader();
    useHeaderScrollFeatures();
    useMainMenu();
    useSmartBanner();
    useGlobalNotification();

    mountUserMenu();

    // Mounts the user menu vue.js component to the DOM
    function mountUserMenu() {
        const mountRoot = document.getElementById("user-menu");
        if (mountRoot === null) return;

        const namedComponent = {
            name: "[APP]: User Menu",
            render: () => h(UserMenu),
        };

        const component = createApp(namedComponent);
        component.use(pinia);
        component.mount(mountRoot);
    }
};
